<div [attr.data-qa]="qaTag"
     [class.modal-dialog-fixed-width]="shouldUseFixedDialogWidth"
     class="modal-dialog">
    @if (modalData.titleTranslationKey) {
        <h2 [attr.data-qa]="qaTag + '-title'"
            class="modal-dialog-title">{{ modalData.titleTranslationKey | translate: modalData.translateKeyParameters }}</h2>
    }
    <span [attr.data-qa]="qaTag + '-message'"
          [class]="messageCssClass"
          [innerHTML]="modalData.messageTranslationKey | translate: modalData.translateKeyParameters"></span>
    @if (modalData.actionTranslationKey) {
        <app-button (clicked)="dismissWithAction()"
                    [appButtonType]="AppButtonTypeEnum.TEXT_ONLY_BUTTON"
                    [buttonColor]="ButtonColorEnum.RED"
                    [buttonText]="modalData.actionTranslationKey | translate : modalData.translateKeyParameters"
                    [qaTag]="qaTag + '-button'"
                    class="modal-dialog-action-button"/>
    }
</div>
